import { useEffect, useState } from 'react';

export function useTechLeadAssignment(params: { liderTecnicoId: string | null | undefined; assignTechLead: (techLeadId: string) => Promise<string | null>; genericErrorMessage: string }) {
    const { liderTecnicoId, assignTechLead, genericErrorMessage } = params;
    const [selectedTechLeadId, setSelectedTechLeadId] = useState('');
    const [assigning, setAssigning] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (liderTecnicoId) {
            setSelectedTechLeadId(liderTecnicoId);
        }
    }, [liderTecnicoId]);

    const selectTechLead = (id: string) => {
        setSelectedTechLeadId(id);
        setError(null);
    };

    const assign = async () => {
        if (!selectedTechLeadId) {
            return;
        }
        setError(null);
        setAssigning(true);
        try {
            const err = await assignTechLead(selectedTechLeadId);
            if (err) {
                setError(err);
            }
        } catch {
            setError(genericErrorMessage);
        } finally {
            setAssigning(false);
        }
    };

    return { selectedTechLeadId, selectTechLead, assigning, error, assign };
}
